import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import Heading from 'components/v2/Heading'

const MainHeader = styled.div<TSFixMe>`
  padding: 40px 20px;
`

export const ChangesHeader = (props: TSFixMe): TSFixMe => {
  return (
    <MainHeader>
      <Heading.H3>
        <FormattedMessage id="changes.header.label" defaultMessage="Changes" />
      </Heading.H3>
    </MainHeader>
  )
}
